export const TIME_ZONES = [
	'Africa/Abidjan',
	'Africa/Accra',
	'Africa/Algiers',
	'Africa/Bissau',
	'Africa/Cairo',
	'Africa/Casablanca',
	'Africa/Ceuta',
	'Africa/El_Aaiun',
	'Africa/Johannesburg',
	'Africa/Juba',
	'Africa/Khartoum',
	'Africa/Lagos',
	'Africa/Maputo',
	'Africa/Monrovia',
	'Africa/Nairobi',
	'Africa/Ndjamena',
	'Africa/Sao_Tome',
	'Africa/Tripoli',
	'Africa/Tunis',
	'Africa/Windhoek',
	'America/Adak',
	'America/Anchorage',
	'America/Araguaina',
	'America/Argentina/Buenos_Aires',
	'America/Argentina/Catamarca',
	'America/Argentina/Cordoba',
	'America/Argentina/Jujuy',
	'America/Argentina/La_Rioja',
	'America/Argentina/Mendoza',
	'America/Argentina/Rio_Gallegos',
	'America/Argentina/Salta',
	'America/Argentina/San_Juan',
	'America/Argentina/San_Luis',
	'America/Argentina/Tucuman',
	'America/Argentina/Ushuaia',
	'America/Asuncion',
	'America/Atikokan',
	'America/Bahia',
	'America/Bahia_Banderas',
	'America/Barbados',
	'America/Belem',
	'America/Belize',
	'America/Blanc-Sablon',
	'America/Boa_Vista',
	'America/Bogota',
	'America/Boise',
	'America/Cambridge_Bay',
	'America/Campo_Grande',
	'America/Cancun',
	'America/Caracas',
	'America/Cayenne',
	'America/Chicago',
	'America/Chihuahua',
	'America/Costa_Rica',
	'America/Creston',
	'America/Cuiaba',
	'America/Curacao',
	'America/Danmarkshavn',
	'America/Dawson',
	'America/Dawson_Creek',
	'America/Denver',
	'America/Detroit',
	'America/Edmonton',
	'America/Eirunepe',
	'America/El_Salvador',
	'America/Fort_Nelson',
	'America/Fortaleza',
	'America/Glace_Bay',
	'America/Godthab',
	'America/Goose_Bay',
	'America/Grand_Turk',
	'America/Guatemala',
	'America/Guayaquil',
	'America/Guyana',
	'America/Halifax',
	'America/Havana',
	'America/Hermosillo',
	'America/Indiana/Indianapolis',
	'America/Indiana/Knox',
	'America/Indiana/Marengo',
	'America/Indiana/Petersburg',
	'America/Indiana/Tell_City',
	'America/Indiana/Vevay',
	'America/Indiana/Vincennes',
	'America/Indiana/Winamac',
	'America/Inuvik',
	'America/Iqaluit',
	'America/Jamaica',
	'America/Juneau',
	'America/Kentucky/Louisville',
	'America/Kentucky/Monticello',
	'America/La_Paz',
	'America/Lima',
	'America/Los_Angeles',
	'America/Maceio',
	'America/Managua',
	'America/Manaus',
	'America/Martinique',
	'America/Matamoros',
	'America/Mazatlan',
	'America/Menominee',
	'America/Merida',
	'America/Metlakatla',
	'America/Mexico_City',
	'America/Miquelon',
	'America/Moncton',
	'America/Monterrey',
	'America/Montevideo',
	'America/Nassau',
	'America/New_York',
	'America/Nipigon',
	'America/Nome',
	'America/Noronha',
	'America/North_Dakota/Beulah',
	'America/North_Dakota/Center',
	'America/North_Dakota/New_Salem',
	'America/Ojinaga',
	'America/Panama',
	'America/Pangnirtung',
	'America/Paramaribo',
	'America/Phoenix',
	'America/Port-au-Prince',
	'America/Port_of_Spain',
	'America/Porto_Velho',
	'America/Puerto_Rico',
	'America/Punta_Arenas',
	'America/Rainy_River',
	'America/Rankin_Inlet',
	'America/Recife',
	'America/Regina',
	'America/Resolute',
	'America/Rio_Branco',
	'America/Santarem',
	'America/Santiago',
	'America/Santo_Domingo',
	'America/Sao_Paulo',
	'America/Scoresbysund',
	'America/Sitka',
	'America/St_Johns',
	'America/Swift_Current',
	'America/Tegucigalpa',
	'America/Thule',
	'America/Thunder_Bay',
	'America/Tijuana',
	'America/Toronto',
	'America/Vancouver',
	'America/Whitehorse',
	'America/Winnipeg',
	'America/Yakutat',
	'America/Yellowknife',
	'Antarctica/Casey',
	'Antarctica/Davis',
	'Antarctica/DumontDUrville', // https://bugs.chromium.org/p/chromium/issues/detail?id=928068
	'Antarctica/Macquarie',
	'Antarctica/Mawson',
	'Antarctica/Palmer',
	'Antarctica/Rothera',
	'Antarctica/Syowa',
	'Antarctica/Troll',
	'Antarctica/Vostok',
	'Asia/Almaty',
	'Asia/Amman',
	'Asia/Anadyr',
	'Asia/Aqtau',
	'Asia/Aqtobe',
	'Asia/Ashgabat',
	'Asia/Atyrau',
	'Asia/Baghdad',
	'Asia/Baku',
	'Asia/Bangkok',
	'Asia/Barnaul',
	'Asia/Beirut',
	'Asia/Bishkek',
	'Asia/Brunei',
	'Asia/Chita',
	'Asia/Choibalsan',
	'Asia/Colombo',
	'Asia/Damascus',
	'Asia/Dhaka',
	'Asia/Dili',
	'Asia/Dubai',
	'Asia/Dushanbe',
	'Asia/Famagusta',
	'Asia/Gaza',
	'Asia/Hebron',
	'Asia/Ho_Chi_Minh',
	'Asia/Hong_Kong',
	'Asia/Hovd',
	'Asia/Irkutsk',
	'Asia/Jakarta',
	'Asia/Jayapura',
	'Asia/Jerusalem',
	'Asia/Kabul',
	'Asia/Kamchatka',
	'Asia/Karachi',
	'Asia/Kathmandu',
	'Asia/Khandyga',
	'Asia/Kolkata',
	'Asia/Krasnoyarsk',
	'Asia/Kuala_Lumpur',
	'Asia/Kuching',
	'Asia/Macau',
	'Asia/Magadan',
	'Asia/Makassar',
	'Asia/Manila',
	'Asia/Nicosia',
	'Asia/Novokuznetsk',
	'Asia/Novosibirsk',
	'Asia/Omsk',
	'Asia/Oral',
	'Asia/Pontianak',
	'Asia/Pyongyang',
	'Asia/Qatar',
	'Asia/Qostanay', // https://bugs.chromium.org/p/chromium/issues/detail?id=928068
	'Asia/Qyzylorda',
	'Asia/Riyadh',
	'Asia/Sakhalin',
	'Asia/Samarkand',
	'Asia/Seoul',
	'Asia/Shanghai',
	'Asia/Singapore',
	'Asia/Srednekolymsk',
	'Asia/Taipei',
	'Asia/Tashkent',
	'Asia/Tbilisi',
	'Asia/Tehran',
	'Asia/Thimphu',
	'Asia/Tokyo',
	'Asia/Tomsk',
	'Asia/Ulaanbaatar',
	'Asia/Urumqi',
	'Asia/Ust-Nera',
	'Asia/Vladivostok',
	'Asia/Yakutsk',
	'Asia/Yangon',
	'Asia/Yekaterinburg',
	'Asia/Yerevan',
	'Atlantic/Azores',
	'Atlantic/Bermuda',
	'Atlantic/Canary',
	'Atlantic/Cape_Verde',
	'Atlantic/Faroe',
	'Atlantic/Madeira',
	'Atlantic/Reykjavik',
	'Atlantic/South_Georgia',
	'Atlantic/Stanley',
	'Australia/Adelaide',
	'Australia/Brisbane',
	'Australia/Broken_Hill',
	'Australia/Currie',
	'Australia/Darwin',
	'Australia/Eucla',
	'Australia/Hobart',
	'Australia/Lindeman',
	'Australia/Lord_Howe',
	'Australia/Melbourne',
	'Australia/Perth',
	'Australia/Sydney',
	'Europe/Amsterdam',
	'Europe/Andorra',
	'Europe/Astrakhan',
	'Europe/Athens',
	'Europe/Belgrade',
	'Europe/Berlin',
	'Europe/Brussels',
	'Europe/Bucharest',
	'Europe/Budapest',
	'Europe/Chisinau',
	'Europe/Copenhagen',
	'Europe/Dublin',
	'Europe/Gibraltar',
	'Europe/Helsinki',
	'Europe/Istanbul',
	'Europe/Kaliningrad',
	'Europe/Kiev',
	'Europe/Kirov',
	'Europe/Lisbon',
	'Europe/London',
	'Europe/Luxembourg',
	'Europe/Madrid',
	'Europe/Malta',
	'Europe/Minsk',
	'Europe/Monaco',
	'Europe/Moscow',
	'Europe/Oslo',
	'Europe/Paris',
	'Europe/Prague',
	'Europe/Riga',
	'Europe/Rome',
	'Europe/Samara',
	'Europe/Saratov',
	'Europe/Simferopol',
	'Europe/Sofia',
	'Europe/Stockholm',
	'Europe/Tallinn',
	'Europe/Tirane',
	'Europe/Ulyanovsk',
	'Europe/Uzhgorod',
	'Europe/Vienna',
	'Europe/Vilnius',
	'Europe/Volgograd',
	'Europe/Warsaw',
	'Europe/Zaporozhye',
	'Europe/Zurich',
	'Indian/Chagos',
	'Indian/Christmas',
	'Indian/Cocos',
	'Indian/Kerguelen',
	'Indian/Mahe',
	'Indian/Maldives',
	'Indian/Mauritius',
	'Indian/Reunion',
	'Pacific/Apia',
	'Pacific/Auckland',
	'Pacific/Bougainville',
	'Pacific/Chatham',
	'Pacific/Chuuk',
	'Pacific/Easter',
	'Pacific/Efate',
	'Pacific/Enderbury',
	'Pacific/Fakaofo',
	'Pacific/Fiji',
	'Pacific/Funafuti',
	'Pacific/Galapagos',
	'Pacific/Gambier',
	'Pacific/Guadalcanal',
	'Pacific/Guam',
	'Pacific/Honolulu',
	'Pacific/Kiritimati',
	'Pacific/Kosrae',
	'Pacific/Kwajalein',
	'Pacific/Majuro',
	'Pacific/Marquesas',
	'Pacific/Nauru',
	'Pacific/Niue',
	'Pacific/Norfolk',
	'Pacific/Noumea',
	'Pacific/Pago_Pago',
	'Pacific/Palau',
	'Pacific/Pitcairn',
	'Pacific/Pohnpei',
	'Pacific/Port_Moresby',
	'Pacific/Rarotonga',
	'Pacific/Tahiti',
	'Pacific/Tarawa',
	'Pacific/Tongatapu',
	'Pacific/Wake',
	'Pacific/Wallis',
];

// Get the user's current time zone
export const GetUserTimeZone = () => {
	try {
		const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
		if (TIME_ZONES.includes(tz)) {
			return tz;
		} else {
			console.error('Error getting user time zone.');
			return 'America/New_York';
		}
	}
	catch (error) {
		console.error('Error getting user time zone:', error);
		return 'America/New_York';
	}
}

// This is a list of timezones that are used in Windows.
export const TIMEZONES_WINDOWS = [
	{ label: '(UTC-12:00) International Date Line West', value: 'Dateline Standard Time' },
	{ label: '(UTC-11:00) Coordinated Universal Time-11', value: 'UTC-11' },
	{ label: '(UTC-10:00) Aleutian Islands', value: 'Aleutian Standard Time' },
	{ label: '(UTC-10:00) Hawaii', value: 'Hawaiian Standard Time' },
	{ label: '(UTC-09:00) Alaska', value: 'Alaskan Standard Time' },
	{ label: '(UTC-09:00) Coordinated Universal Time-09', value: 'UTC-09' },
	{ label: '(UTC-09:30) Marquesas Islands', value: 'Marquesas Standard Time' },
	{ label: '(UTC-08:00) Baja California', value: 'Pacific Standard Time (Mexico)' },
	{ label: '(UTC-08:00) Coordinated Universal Time-08', value: 'UTC-08' },
	{ label: '(UTC-08:00) Pacific Time (US & Canada)', value: 'Pacific Standard Time' },
	{ label: '(UTC-07:00) Arizona', value: 'US Mountain Standard Time' },
	{ label: '(UTC-07:00) La Paz, Mazatlan', value: 'Mountain Standard Time (Mexico)' },
	{ label: '(UTC-07:00) Mountain Time (US & Canada)', value: 'Mountain Standard Time' },
	{ label: '(UTC-07:00) Yukon', value: 'Yukon Standard Time' },
	{ label: '(UTC-06:00) Central America', value: 'Central America Standard Time' },
	{ label: '(UTC-06:00) Central Time (US & Canada)', value: 'Central Standard Time' },
	{ label: '(UTC-06:00) Easter Island', value: 'Easter Island Standard Time' },
	{ label: '(UTC-06:00) Guadalajara, Mexico City, Monterrey', value: 'Central Standard Time (Mexico)' },
	{ label: '(UTC-06:00) Saskatchewan', value: 'Canada Central Standard Time' },
	{ label: '(UTC-05:00) Bogota, Lima, Quito, Rio Branco', value: 'SA Pacific Standard Time' },
	{ label: '(UTC-05:00) Chetumal', value: 'Eastern Standard Time (Mexico)' },
	{ label: '(UTC-05:00) Eastern Time (US & Canada)', value: 'Eastern Standard Time' },
	{ label: '(UTC-05:00) Haiti', value: 'Haiti Standard Time' },
	{ label: '(UTC-05:00) Havana', value: 'Cuba Standard Time' },
	{ label: '(UTC-05:00) Indiana (East)', value: 'US Eastern Standard Time' },
	{ label: '(UTC-05:00) Turks and Caicos', value: 'Turks and Caicos Standard Time' },
	{ label: '(UTC-04:00) Atlantic Time (Canada)', value: 'Atlantic Standard Time' },
	{ label: '(UTC-04:00) Caracas', value: 'Venezuela Standard Time' },
	{ label: '(UTC-04:00) Cuiaba', value: 'Central Brazilian Standard Time' },
	{ label: '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan', value: 'SA Western Standard Time' },
	{ label: '(UTC-04:00) Santiago', value: 'Pacific SA Standard Time' },
	{ label: '(UTC-03:00) Araguaina', value: 'Tocantins Standard Time' },
	{ label: '(UTC-03:00) Asuncion', value: 'Paraguay Standard Time' },
	{ label: '(UTC-03:00) Brasilia', value: 'E. South America Standard Time' },
	{ label: '(UTC-03:00) Cayenne, Fortaleza', value: 'SA Eastern Standard Time' },
	{ label: '(UTC-03:00) City of Buenos Aires', value: 'Argentina Standard Time' },
	{ label: '(UTC-03:00) Montevideo', value: 'Montevideo Standard Time' },
	{ label: '(UTC-03:00) Punta Arenas', value: 'Magallanes Standard Time' },
	{ label: '(UTC-03:00) Saint Pierre and Miquelon', value: 'Saint Pierre Standard Time' },
	{ label: '(UTC-03:00) Salvador', value: 'Bahia Standard Time' },
	{ label: '(UTC-03:30) Newfoundland', value: 'Newfoundland Standard Time' },
	{ label: '(UTC-02:00) Coordinated Universal Time-02', value: 'UTC-02' },
	{ label: '(UTC-02:00) Greenland', value: 'Greenland Standard Time' },
	{ label: '(UTC-02:00) Mid-Atlantic - Old', value: 'Mid-Atlantic Standard Time' },
	{ label: '(UTC-01:00) Azores', value: 'Azores Standard Time' },
	{ label: '(UTC-01:00) Cabo Verde Is.', value: 'Cabo Verde Standard Time' },
	{ label: '(UTC) Coordinated Universal Time', value: 'Coordinated Universal Time' },
	{ label: '(UTC+00:00) Dublin, Edinburgh, Lisbon, London', value: 'GMT Standard Time' },
	{ label: '(UTC+00:00) Monrovia, Reykjavik', value: 'Greenwich Standard Time' },
	{ label: '(UTC+00:00) Sao Tome', value: 'Sao Tome Standard Time' },
	{ label: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna', value: 'W. Europe Standard Time' },
	{ label: '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague', value: 'Central Europe Standard Time' },
	{ label: '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris', value: 'Romance Standard Time' },
	{ label: '(UTC+01:00) Casablanca', value: 'Morocco Standard Time' },
	{ label: '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb', value: 'Central European Standard Time' },
	{ label: '(UTC+01:00) West Central Africa', value: 'W. Central Africa Standard Time' },
	{ label: '(UTC+02:00) Athens, Bucharest', value: 'GTB Standard Time' },
	{ label: '(UTC+02:00) Beirut', value: 'Middle East Standard Time' },
	{ label: '(UTC+02:00) Cairo', value: 'Egypt Standard Time' },
	{ label: '(UTC+02:00) Chisinau', value: 'E. Europe Standard Time' },
	{ label: '(UTC+02:00) Gaza, Hebron', value: 'West Bank Gaza Standard Time' },
	{ label: '(UTC+02:00) Harare, Pretoria', value: 'South Africa Standard Time' },
	{ label: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius', value: 'FLE Standard Time' },
	{ label: '(UTC+02:00) Jerusalem', value: 'Jerusalem Standard Time' },
	{ label: '(UTC+02:00) Juba', value: 'South Sudan Standard Time' },
	{ label: '(UTC+02:00) Kaliningrad', value: 'Russia TZ 1 Standard Time' },
	{ label: '(UTC+02:00) Khartoum', value: 'Sudan Standard Time' },
	{ label: '(UTC+02:00) Tripoli', value: 'Libya Standard Time' },
	{ label: '(UTC+02:00) Windhoek', value: 'Namibia Standard Time' },
	{ label: '(UTC+03:00) Amman', value: 'Jordan Standard Time' },
	{ label: '(UTC+03:00) Baghdad', value: 'Arabic Standard Time' },
	{ label: '(UTC+03:00) Damascus', value: 'Syria Standard Time' },
	{ label: '(UTC+03:00) Istanbul', value: 'Turkey Standard Time' },
	{ label: '(UTC+03:00) Kuwait, Riyadh', value: 'Arab Standard Time' },
	{ label: '(UTC+03:00) Minsk', value: 'Belarus Standard Time' },
	{ label: '(UTC+03:00) Moscow, St. Petersburg', value: 'Russia TZ 2 Standard Time' },
	{ label: '(UTC+03:00) Nairobi', value: 'E. Africa Standard Time' },
	{ label: '(UTC+03:00) Volgograd', value: 'Volgograd Standard Time' },
	{ label: '(UTC+03:30) Tehran', value: 'Iran Standard Time' },
	{ label: '(UTC+04:00) Abu Dhabi, Muscat', value: 'Arabian Standard Time' },
	{ label: '(UTC+04:00) Astrakhan, Ulyanovsk', value: 'Astrakhan Standard Time' },
	{ label: '(UTC+04:00) Baku', value: 'Azerbaijan Standard Time' },
	{ label: '(UTC+04:00) Izhevsk, Samara', value: 'Russia TZ 3 Standard Time' },
	{ label: '(UTC+04:00) Port Louis', value: 'Mauritius Standard Time' },
	{ label: '(UTC+04:00) Saratov', value: 'Saratov Standard Time' },
	{ label: '(UTC+04:00) Tbilisi', value: 'Georgian Standard Time' },
	{ label: '(UTC+04:00) Yerevan', value: 'Caucasus Standard Time' },
	{ label: '(UTC+04:30) Kabul', value: 'Afghanistan Standard Time' },
	{ label: '(UTC+05:00) Ashgabat, Tashkent', value: 'West Asia Standard Time' },
	{ label: '(UTC+05:00) Astana', value: 'Qyzylorda Standard Time' },
	{ label: '(UTC+05:00) Ekaterinburg', value: 'Russia TZ 4 Standard Time' },
	{ label: '(UTC+05:00) Islamabad, Karachi', value: 'Pakistan Standard Time' },
	{ label: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi', value: 'India Standard Time' },
	{ label: '(UTC+05:30) Sri Jayawardenepura', value: 'Sri Lanka Standard Time' },
	{ label: '(UTC+05:45) Kathmandu', value: 'Nepal Standard Time' },
	{ label: '(UTC+06:00) Bishkek', value: 'Central Asia Standard Time' },
	{ label: '(UTC+06:00) Dhaka', value: 'Bangladesh Standard Time' },
	{ label: '(UTC+06:00) Omsk', value: 'Omsk Standard Time' },
	{ label: '(UTC+06:30) Yangon (Rangoon)', value: 'Myanmar Standard Time' },
	{ label: '(UTC+07:00) Bangkok, Hanoi, Jakarta', value: 'SE Asia Standard Time' },
	{ label: '(UTC+07:00) Barnaul, Gorno-Altaysk', value: 'Altai Standard Time' },
	{ label: '(UTC+07:00) Hovd', value: 'W. Mongolia Standard Time' },
	{ label: '(UTC+07:00) Krasnoyarsk', value: 'Russia TZ 6 Standard Time' },
	{ label: '(UTC+07:00) Novosibirsk', value: 'Novosibirsk Standard Time' },
	{ label: '(UTC+07:00) Tomsk', value: 'Tomsk Standard Time' },
	{ label: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi', value: 'China Standard Time' },
	{ label: '(UTC+08:00) Irkutsk', value: 'Russia TZ 7 Standard Time' },
	{ label: '(UTC+08:00) Kuala Lumpur, Singapore', value: 'Malay Peninsula Standard Time' },
	{ label: '(UTC+08:00) Perth', value: 'W. Australia Standard Time' },
	{ label: '(UTC+08:00) Taipei', value: 'Taipei Standard Time' },
	{ label: '(UTC+08:00) Ulaanbaatar', value: 'Ulaanbaatar Standard Time' },
	{ label: '(UTC+08:45) Eucla', value: 'Aus Central W. Standard Time' },
	{ label: '(UTC+09:00) Chita', value: 'Transbaikal Standard Time' },
	{ label: '(UTC+09:00) Osaka, Sapporo, Tokyo', value: 'Tokyo Standard Time' },
	{ label: '(UTC+09:00) Pyongyang', value: 'North Korea Standard Time' },
	{ label: '(UTC+09:00) Seoul', value: 'Korea Standard Time' },
	{ label: '(UTC+09:00) Yakutsk', value: 'Russia TZ 8 Standard Time' },
	{ label: '(UTC+09:30) Adelaide', value: 'Cen. Australia Standard Time' },
	{ label: '(UTC+09:30) Darwin', value: 'AUS Central Standard Time' },
	{ label: '(UTC+10:00) Brisbane', value: 'E. Australia Standard Time' },
	{ label: '(UTC+10:00) Canberra, Melbourne, Sydney', value: 'AUS Eastern Standard Time' },
	{ label: '(UTC+10:00) Guam, Port Moresby', value: 'West Pacific Standard Time' },
	{ label: '(UTC+10:00) Hobart', value: 'Tasmania Standard Time' },
	{ label: '(UTC+10:00) Vladivostok', value: 'Russia TZ 9 Standard Time' },
	{ label: '(UTC+10:30) Lord Howe Island', value: 'Lord Howe Standard Time' },
	{ label: '(UTC+11:00) Bougainville Island', value: 'Bougainville Standard Time' },
	{ label: '(UTC+11:00) Chokurdakh', value: 'Russia TZ 10 Standard Time' },
	{ label: '(UTC+11:00) Magadan', value: 'Magadan Standard Time' },
	{ label: '(UTC+11:00) Norfolk Island', value: 'Norfolk Standard Time' },
	{ label: '(UTC+11:00) Sakhalin', value: 'Sakhalin Standard Time' },
	{ label: '(UTC+11:00) Solomon Is., New Caledonia', value: 'Central Pacific Standard Time' },
	{ label: '(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky', value: 'Russia TZ 11 Standard Time' },
	{ label: '(UTC+12:00) Auckland, Wellington', value: 'New Zealand Standard Time' },
	{ label: '(UTC+12:00) Coordinated Universal Time+12', value: 'UTC+12' },
	{ label: '(UTC+12:00) Fiji', value: 'Fiji Standard Time' },
	{ label: '(UTC+12:00) Petropavlovsk-Kamchatsky - Old', value: 'Kamchatka Standard Time' },
	{ label: '(UTC+12:45) Chatham Islands', value: 'Chatham Islands Standard Time' },
	{ label: '(UTC+13:00) Coordinated Universal Time+13', value: 'UTC+13' },
	{ label: '(UTC+13:00) Nuku\'alofa', value: 'Tonga Standard Time' },
	{ label: '(UTC+13:00) Samoa', value: 'Samoa Standard Time' },
	{ label: '(UTC+14:00) Kiritimati Island', value: 'Line Islands Standard Time' },
];